export default __webpack_public_path__ + "static/media/Shape.cab9d38e.svg";